var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcommingEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "#E6F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.75 32.2007V30.5H33.25C34.4926 30.5 35.5 29.4926 35.5 28.25V15.5H36.25C36.6642 15.5 37 15.1642 37 14.75C37 14.3358 36.6642 14 36.25 14H13.75C13.3358 14 13 14.3358 13 14.75C13 15.1642 13.3358 15.5 13.75 15.5H14.5V28.25C14.5 29.4926 15.5074 30.5 16.75 30.5H24.25V32.2007C23.8016 32.46 23.5 32.9448 23.5 33.5C23.5 34.3284 24.1716 35 25 35C25.8284 35 26.5 34.3284 26.5 33.5C26.5 32.9448 26.1984 32.46 25.75 32.2007ZM16 15.5V28.25C16 28.6642 16.3358 29 16.75 29H33.25C33.6642 29 34 28.6642 34 28.25V15.5H16Z",
    fill: "#128B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcommingEvents);
export default __webpack_public_path__ + "static/media/upcomming-events.88ef348e9bfd5e112071e6e449a9f40c.svg";
export { ForwardRef as ReactComponent };